import { UiControlConstants } from "../../common/uicontrol-constants";
import { PopperDelegate } from "../popper/popper";
import { CustomKeyValues, TelemetryService } from "../../logger/telemetry-service";
import { GlobalTelemetryConstants } from "../../logger/telemetry-constants";
import { ActionRegistry } from "../../../ServiceDesk/sdServices/agent-action/registry-contract";

/** ###Do Not Display### */
export class ActionMenuBinding {
  /** The actionItems should be an array of objects where each object represents data for action.
   *  The action item should contain a property "displayName" which will be used to render the name of the action item.
   *  the action item may contain a property "automationId" which will be used to location the action while end to end test automation.
   */
  public actionItems = "<";

  /** Boolean: set to true for right-aligned (defaults to left-aligned). */
  public alignRight = "<?";

  /** The callback function that invokes the action.*/
  public invokeAction = "&";

  /** The callback function to check the UI state of an action. Should return an enum of type ServiceDesk.Controls.MultiAction.ActionUiState */
  public getActionUiState = "&";

  /** The callback function to get attribute options of parent. */
  public getAttributeOptions = "&?";

  /** The metaTags for loggind awa event telemetry, includes scenario and scenario steps */
  public metaTags = "<";

  public telemetryData = "<";

  public ariaLabel = "@?";
}

export class ActionMenuHoverBinding extends ActionMenuBinding {
  /** Parent item for hover menu */
  public parentItem = "<";

  /** The callback function that invokes the action.*/
  public invokeAction = "<";

  /** Name of hover actions. */
  public hoverActionName = "<";

  /** The callback function to get attribute options of parent. */
  public getAttributeOptions = "<";
}

export class ActionMenuController {
  public actionItems: any;
  public ariaLabelActionMenu: any;
  public alignRight: boolean;
  public invokeAction: (arg: { actionItem: any }) => boolean;
  public getActionUiState: (arg: { actionItem: any }) => any;
  public popperDelegateObj: PopperDelegate;
  private validActionSelector = ".action-item.action-valid";
  private metaTags: CustomKeyValues;
  private telemetryData: CustomKeyValues;
  // @ngInject
  constructor(
    protected $element: ng.IAugmentedJQuery,
    protected actionRegistryService: ActionRegistry,
    protected telemetryService: TelemetryService,
    protected telemetryConstants: GlobalTelemetryConstants,
    protected uiControlConstants: UiControlConstants
  ) {}

  public onPopperInitialized(popperDelegateObj: PopperDelegate) {
    this.popperDelegateObj = popperDelegateObj;
  }

  public onOpened() {
    // popper element is attached to DOM only when the popper is opened.
    let popperElement = angular.element(`#${this.popperDelegateObj.id}`);
    popperElement.find(this.validActionSelector).first().focus();
  }

  public navigateActionFlyout($event: any, item: any) {
    switch ($event.keyCode) {
      case this.uiControlConstants.keyCode.upArrowKeyCode:
        this.navigateToPreviousValidAction($event.target);
        break;
      case this.uiControlConstants.keyCode.downArrowKeyCode:
        this.navigateToNextValidAction($event.target);
        break;
      case this.uiControlConstants.keyCode.spaceKeyCode:
      case this.uiControlConstants.keyCode.enterKeyCode:
        this.actionItemSelected($event, item);
        break;
      case this.uiControlConstants.keyCode.escapeKeyCode:
        this.popperDelegateObj.close();
        break;
      default:
        return;
    }

    $event.preventDefault();
    $event.stopPropagation();
  }

  public navigateToPreviousValidAction(target: any) {
    $(target).prevAll(this.validActionSelector).first().focus();
  }

  public navigateToNextValidAction(target: any) {
    $(target).nextAll(this.validActionSelector).first().focus();
  }

  public actionItemSelected($event: ng.IAngularEvent, actionItem: any) {
    this.telemetryService.pushPageActionEvent(
      this.telemetryConstants.pageActionType.click,
      this.telemetryConstants.pageActionBehavior.Navigate,
      this.metaTags,
      this.telemetryData
    );
    if (this.invokeAction) {
      if (!actionItem.hoverActionName && this.invokeAction({ actionItem: actionItem })) {
        this.popperDelegateObj.close();
      }
    }

    if (!actionItem.hoverActionName) {
      $event.preventDefault();
      $event.stopPropagation();
    }
  }

  public checkActionValidility(item: any): boolean {
    return this.getActionState(item) == this.uiControlConstants.multiActionUiState.Valid;
  }

  public checkIfActionIsNotAllowed(item: any): boolean {
    return this.getActionState(item) == this.uiControlConstants.multiActionUiState.NotAllowed;
  }

  public checkIfActionShouldBeShown(item: any): boolean {
    return this.getActionState(item) != this.uiControlConstants.multiActionUiState.NotKnown;
  }

  public getActionState(item: any): any {
    if (angular.isFunction(this.getActionUiState)) {
      return this.getActionUiState({ actionItem: item });
    }
  }
}

export class ActionMenuHoverController extends ActionMenuController {
  public parentItem: any;
  public isContentHovered: boolean;
  public hoverActionName: string;
  public getAttributeOptions: (args: { name: string }) => any;
  // @ngInject
  constructor(
    $element: ng.IAugmentedJQuery,
    actionRegistryService: ActionRegistry,
    telemetryService: TelemetryService,
    telemetryConstants: GlobalTelemetryConstants,
    uiControlConstants: UiControlConstants
  ) {
    super($element, actionRegistryService, telemetryService, telemetryConstants, uiControlConstants);
  }

  public $onInit(): void {
    this.actionItems = this.actionRegistryService.getMultiActionTriggerLinks(
      this.getAttributeOptions({ name: this.hoverActionName }),
      this.$element
    );
  }

  public onOpened(): void {
    this.$onInit();
  }
}

export const sdActionMenu: ng.IComponentOptions = {
  bindings: <any>new ActionMenuBinding(),
  controller: ActionMenuController,
  templateUrl: "../ShellCommon/Controls/multi-action/action-menu.html"
};

export const sdActionMenuHover: ng.IComponentOptions = {
  bindings: <any>new ActionMenuHoverBinding(),
  controller: ActionMenuHoverController,
  templateUrl: "../ShellCommon/Controls/multi-action/action-menu-hover.html"
};
